// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../statics/login_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../statics/wechat_container_little.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../statics/wechat_container.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../statics/mobile_browser.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_container__lJTml {
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* 设置背景图片 */
    background-size: cover; /* 覆盖整个 div 区域 */
    background-repeat: no-repeat; /* 防止背景图片重复 */
    background-position: center center; /* 中心对齐背景图片 */
}

.login_container_loading__xeMxe {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

.login_mobile_container__dBKtc,
.login_wechat_container__FTRXE,
.login_qywechat_container__D4CaE {
    position: relative;
    width: 100%;
    height: 100%;
}

.login_qywechat_container__D4CaE {
    display: flex;
    justify-content: center;
    align-items: center;
}

/* 默认样式（小屏幕时使用图片） */
.login_wechat_bg_img__YU5WN {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / 100% 100%;
}

.login_wechat_bg_arrow__0sbtU {
    width: 90px;
    height: 90px;
    position: absolute;
    top: 40px;
    right: 40px;
}

/* 大屏幕样式（当屏幕宽度大于 1600px 时使用图片） */
@media (min-width: 1300px) {
    .login_wechat_bg_img__YU5WN {
        background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center / 100% 100%;
    }

    .login_wechat_bg_arrow__0sbtU {
        width: 150px;
        height: 150px;
        top: 60px;
        right: 60px;
    }
}

.login_mobile_bg_img__r1b54 {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center / 100% 100%;
}
.login_mobile_qywechat_container__evtuB .login_qywechat_loading__qrjAv {
    width: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/login/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,yDAAmD,EAAE,WAAW;IAChE,sBAAsB,EAAE,gBAAgB;IACxC,4BAA4B,EAAE,aAAa;IAC3C,kCAAkC,EAAE,aAAa;AACrD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;;;IAGI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,gFAAyF;AAC7F;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA,gCAAgC;AAChC;IACI;QACI,gFAAkF;IACtF;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,SAAS;QACT,WAAW;IACf;AACJ;;AAEA;IACI,gFAAgF;AACpF;AACA;IACI,WAAW;AACf","sourcesContent":[".container {\n    width: 100%;\n    height: 100%;\n    background-image: url('../../statics/login_bg.png'); /* 设置背景图片 */\n    background-size: cover; /* 覆盖整个 div 区域 */\n    background-repeat: no-repeat; /* 防止背景图片重复 */\n    background-position: center center; /* 中心对齐背景图片 */\n}\n\n.container_loading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.mobile_container,\n.wechat_container,\n.qywechat_container {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.qywechat_container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n/* 默认样式（小屏幕时使用图片） */\n.wechat_bg_img {\n    background: url('../../statics/wechat_container_little.png') no-repeat center / 100% 100%;\n}\n\n.wechat_bg_arrow {\n    width: 90px;\n    height: 90px;\n    position: absolute;\n    top: 40px;\n    right: 40px;\n}\n\n/* 大屏幕样式（当屏幕宽度大于 1600px 时使用图片） */\n@media (min-width: 1300px) {\n    .wechat_bg_img {\n        background: url('../../statics/wechat_container.png') no-repeat center / 100% 100%;\n    }\n\n    .wechat_bg_arrow {\n        width: 150px;\n        height: 150px;\n        top: 60px;\n        right: 60px;\n    }\n}\n\n.mobile_bg_img {\n    background: url('../../statics/mobile_browser.png') no-repeat center / 100% 100%;\n}\n.mobile_qywechat_container .qywechat_loading {\n    width: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `login_container__lJTml`,
	"container_loading": `login_container_loading__xeMxe`,
	"mobile_container": `login_mobile_container__dBKtc`,
	"wechat_container": `login_wechat_container__FTRXE`,
	"qywechat_container": `login_qywechat_container__D4CaE`,
	"wechat_bg_img": `login_wechat_bg_img__YU5WN`,
	"wechat_bg_arrow": `login_wechat_bg_arrow__0sbtU`,
	"mobile_bg_img": `login_mobile_bg_img__r1b54`,
	"mobile_qywechat_container": `login_mobile_qywechat_container__evtuB`,
	"qywechat_loading": `login_qywechat_loading__qrjAv`
};
export default ___CSS_LOADER_EXPORT___;
